import { faCss3Alt, faFigma, faGithub, faHtml5, faJs, faLaravel, faPython, faReact } from '@fortawesome/free-brands-svg-icons';
import TS from '../../assets/images/techstacks/typescript.png';
import TW from '../../assets/images/techstacks/tailwindcss.png';
import SCSS from '../../assets/images/techstacks/scss.png';

const techIcons = {
  HTML: {
    name: "HTML",
    icon: faHtml5
  },
  CSS: {
    name: "CSS",
    icon: faCss3Alt
  },
  SCSS: {
    name: "SCSS",
    image: SCSS
  },
  JavaScript: {
    name: "JavaScript",
    icon: faJs
  },
  React: {
    name: "React",
    icon: faReact
  },
  TypeScript: {
    name: "TypeScript",
    image: TS
  },
  Tailwind: {
    name: "TailwindCSS",
    image: TW
  },
  Laravel: {
    name: "Laravel",
    icon: faLaravel
  },
  Python: {
    name: "Python",
    icon: faPython
  },
  Figma: {
    name: "Figma",
    icon: faFigma
  },
  Github: {
    name: "Github",
    icon: faGithub
  },
};

export default techIcons;